import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import 'chart.js/auto';
import { Typography } from '@mui/material';

interface IChartProps {
  countryData: any;
  selectedIndex: string;
}

const BiteListChart: React.FC<IChartProps> = ({ selectedIndex, countryData }) => {
  const labels: any = [];
  const docCount: number[] = [];
  const colors = [
    '#EC4899',
    '#F59E0B',
    '#FACC15',
    '#D5EE39',
    '#96E038',
    '#38E09A',
    '#3B82F6',
    '#4CC9F0',
    '#A855F7',
    '#6366F1',
  ];
  if (selectedIndex === 'Risk Insights') {
    countryData.data.countryAgg.buckets.slice(0, 10).map((country: any, index: number) => {
      labels.push({ country: country.key, color: colors[index] });
      docCount.push(country.doc_count);
    });
  }
  if (selectedIndex === 'PEP') {
    countryData.data.countryAgg.buckets.slice(0, 10).map((country: any, index: number) => {
      labels.push({ country: country.key, color: colors[index] });
      docCount.push(country.doc_count);
    });
  }
  if (selectedIndex === 'Debarred') {
    countryData.data.countryAgg.buckets.map((country: any, index: number) => {
      labels.push({ country: country.key, color: colors[index] });
      docCount.push(country.doc_count);
    });
  }
  if (selectedIndex === 'FF Labor' || selectedIndex === 'ESG Registrations') {
    countryData.data.countryAgg.buckets.map((country: any, index: number) => {
      labels.push({ country: country.key, color: colors[index] });
      docCount.push(country.doc_count);
    });
  }
  const chartData = {
    datasets: [
      {
        data: docCount,
        backgroundColor: [
          '#EC4899',
          '#F59E0B',
          '#FACC15',
          '#D5EE39',
          '#96E038',
          '#38E09A',
          '#3B82F6',
          '#4CC9F0',
          '#A855F7',
          '#6366F1',
        ],
        borderWidth: 0,
        cutout: '75%',
        radius: '70%'
      },
    ]
  };
  return (
    <div className='chart-container'>
      <div className='chart-data'>
        <Doughnut data={chartData} />
        <div className='chart-total'>
          <Typography style={{ fontSize: '16px', fontFamily: 'Inter', color: '#737373', fontWeight: 500 }}>Total Sources</Typography>
          {selectedIndex === 'Risk Insights' && (
            <Typography style={{ textAlign: 'center', fontSize: '36px', fontFamily: 'Inter', color: '#fff', fontWeight: 600 }}>{countryData.data.countryAgg.buckets.length}</Typography>
          )}
          {selectedIndex === 'PEP' && (
            <Typography style={{ textAlign: 'center', fontSize: '36px', fontFamily: 'Inter', color: '#fff', fontWeight: 600 }}>{countryData.data.countryAgg.buckets.length}</Typography>
          )}
          {selectedIndex === 'Debarred' && (
            <Typography style={{ textAlign: 'center', fontSize: '36px', fontFamily: 'Inter', color: '#fff', fontWeight: 600 }}>{countryData.data.countryAgg.buckets.length}</Typography>
          )}
          {(selectedIndex === 'FF Labor' || selectedIndex === 'ESG Registrations') && (
            <Typography style={{ textAlign: 'center', fontSize: '36px', fontFamily: 'Inter', color: '#fff', fontWeight: 600 }}>{countryData.data.countryAgg.buckets.length}</Typography>
          )}
        </div>
      </div>
      <div className='bite-chart-labels'>
        <div className='first-5-labels'>
          {labels.slice(0, 5).map((label: any, index: number) => (
            <div key={index} className='bite-chart-label-item'>
              <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
                <circle cx='6' cy='6' r='6' fill={label.color}/>
              </svg>
              <div className='bite-label-text'>{label.country}</div>
            </div>
          ))}
        </div>
        <div className='last-5-labels'>
          {labels.slice(5, 10).map((label: any, index: number) => (
            <div key={index} className='bite-chart-label-item'>
              <div className='bite-label-frame'>
                <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'>
                  <circle cx='6' cy='6' r='6' fill={label.color}/>
                </svg>
                <div className='bite-label-text'>{label.country}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BiteListChart;
